import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../store/actions";

const AuthProtected = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userProfile, loading } = useProfile();
  const location = useLocation();

  useEffect(() => {
    if (!userProfile && !loading) {
      navigate("/login", { state: { from: location } });
    }
  }, [userProfile, loading, dispatch, navigate, location]);

  if (!userProfile && !loading) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useSelector(state => ({
    user: state.Login.user,
  }));
  const userRole = user?.role || JSON.parse(localStorage.getItem('user') || '{}')?.role || 'unknown';
  const location = useLocation();

  if (allowedRoles.includes(userRole)) {
    return <>{children}</>;
  } else {
    return <Navigate to="/NotAuthorized" state={{ from: location }} replace />;
  }
};

export { AuthProtected, ProtectedRoute };